import TriggerSerializer from 'eflex/serializers/trigger';

export default class NodeRedTriggerSerializer extends TriggerSerializer {
  constructor() {
    super(...arguments);
    this.attrs.variableDefs = { embedded: 'always' };
  }
}
